<template>
  <div class="home__parcours__list__filters__container">
    <div class="home__parcours__list__filters items-center justify-center flex">
      <div
          v-for="category in sortedCategories"
          :key="category.ref"
          class="home__parcours__list__filter flex items-center justify-center tooltip rounded-t-2xl cursor-pointer"
          :class="{ selected: filter === category.ref }"
          @click="switchFilter(category.ref)"
      >
        <span>{{ category.name }}</span>
      </div>
    </div>
  </div>
</template> 

<script>
import { useUserStore } from '@/store/UserStore';
export default {
  data () {
    const UserStore = useUserStore();
    return {
      UserStore: UserStore,
      filter: ''
    }
  },
  computed: {
    sortedCategories() {
      const categories = this.UserStore.courseCategories || [];
      const sorted = [...categories].sort((a, b) => a.order - b.order);
      return sorted;
    }
  },
  mounted() {
    if (this.sortedCategories.length > 0) {
      this.switchFilter(this.sortedCategories[0].ref);
    }
  },
  methods: {
    switchFilter(typeRef) {
      this.filter = typeRef;
      this.$emit('type-updated', typeRef);
    }
  }
}
</script>
